import {Pipe, PipeTransform} from '@angular/core';
import {isBlank} from "../utils/epic.utils";

@Pipe({name: 'firstChar', pure: true, standalone: true})
export class FirstCharPipe implements PipeTransform {

  transform(value: unknown): any {
    if (typeof value !== 'string' || isBlank(value)) {
      return value;
    }
    return value.substring(0, 1);
  }
}
